module.exports = __webpack_public_path__ + "static/img/fish10.8bdf945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish10.png
// module id = KFCT
// module chunks = 0